import LoadingIcon from '@/components/LoadingIcon';
import { LogoutReturnUrlMapping } from '@/config';
import { getUrlQueryValue } from '@/hooks/useQuery';
import authService from '@/services/authService';
import { AppUrls } from '@/urls';
import React from 'react';

type Props = {};

export default function LogoutPage({}: Props) {
  React.useEffect(() => {
    setTimeout(() => {
      authService.clearInfoWhenLogout().finally(() => {
        const returnUrl = getUrlQueryValue('ReturnUrl');
        window.location.href = LogoutReturnUrlMapping[returnUrl || ''] || AppUrls.Login;
      });
    }, 300);
  }, []);
  return (
    <div style={{ width: '100vw', height: '100vh' }} className="d-flex flex-column justify-content-center align-items-center">
      <div>
        <LoadingIcon />
      </div>
      <div>You are logging out</div>
    </div>
  );
}
